import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { auth } from "@/lib/api";

const Ctx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  useEffect(() => { auth.session().then(setUser).catch(() => setUser(false)); }, []);
  const logout = useCallback(async () => { try { await auth.logout(); } finally { setUser(false); } }, []);
  return <Ctx.Provider value={{ user, setUser, logout }}>{children}</Ctx.Provider>;
};

export const useAuth = () => useContext(Ctx);
